import styled from 'styled-components'

import { Reset } from '@/lib/mixins'

export const ProductModalContent = styled.div`
  display: flex;
  gap: 5%;
`

export const ProductModalSection = styled.div`
  min-width: 0;
  flex: 1 1 auto;
`

export const ProductModalTitle = styled.h4`
  font-size: 1.3rem;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${props => props.theme.color.line};
  color: ${props => props.theme.color.muted};
`

export const ProductModalDescription = styled.div`
  margin: 0;
  font-size: 1.1rem;

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 1.5rem;
    font-family: ${props => props.theme.font.primary};
    font-weight: 500;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.6rem;
  }
  h4 {
    font-size: 1.4rem;
  }
  h5 {
    font-size: 1.2rem;
  }

  ul,
  ol {
    li {
      &:not(:last-child) {
        margin-bottom: 0.75rem;
      }
    }
  }

  ul {
    ${Reset('list')}
    margin-bottom: 2rem;

    li {
      position: relative;
      padding-left: 1rem;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.45em;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${props => props.theme.color.primary};
      }
    }
  }
`

export const ProductModalDuration = styled.div`
  min-width: 10rem;
  text-align: right;

  span {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    color: ${props => props.theme.color.muted};
    margin-bottom: 0.35rem;
  }

  strong {
    display: block;
    font-size: 1.5rem;
    line-height: 1.05;
    font-weight: 600;
  }
`

export const ProductModalHero = styled.div`
  display: flex;
  gap: 5%;
  align-items: center;
  margin-bottom: 4rem;
`

export const ProductModalMedia = styled.div`
  flex: 0 0 30%;
  overflow: hidden;
  max-width: 25%;
  aspect-ratio: 1 / 1;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1100px) {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`

export const ProductModalInfo = styled.div`
  h3 {
    font-family: ${props => props.theme.font.primary};
    font-weight: 600;
    font-size: 1.75rem;
    line-height: 1.1;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1.1rem;
    color: ${props => props.theme.color.muted};
    margin: 0;
  }
`

export const ProductModalDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${props => props.theme.color.line};
  margin: 3rem 0;
`
